import { useSelector } from 'react-redux';
import styles from './style.module.css';


export const DetailsContainer = (props) => {
   const ordersListOpen = useSelector((state) => state.SharedData.ordersListOpen)

    return <div className={styles.detailsContainer}  style={{ marginInlineStart: ordersListOpen ? "" : "-465px" ,transition :"300ms all ease-in-out"}}>
        {props.children}
    </div>

};




